const list = {
  path: 'goods',
  component: resolve => require(['@/pages/admin/platform/goods'], resolve)
}

export default list
